import { useState } from 'react';

const initials = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('')
    .toUpperCase();

export function Avatar({
  name,
  photoUrl,
  size,
}: {
  name: string;
  photoUrl?: string | null;
  size?: 'md' | 'lg';
}) {
  const [broken, setBroken] = useState(false);
  return (
    <span className={`avatar${size ? ` ${size}` : ''}`} aria-hidden="true">
      {photoUrl && !broken ? (
        <img
          src={photoUrl}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => setBroken(true)}
        />
      ) : (
        initials(name)
      )}
    </span>
  );
}
